import { InputAdornment } from "@material-ui/core";
import IconCheck from "../icons/IconCheck";

const AdornmentState: React.FC<{ error?: boolean }> = ({ error }) => {

    const endAdornment = (error === false)
        ? <InputAdornment position="start" disableTypography><IconCheck /></InputAdornment>
        : <></>;

    return endAdornment;
}

export default AdornmentState;